/* eslint-disable */
import { useEffect, useState } from "react";
import { LoadingModal } from "../../components";
import GetDrivers from "../../hooks/DriversNikuCar/getDrivers";
import DriverCard from "../../components/drivers-list/DriverCard";
import InputSearch from "../../components/InputSearch/InputSearch";
import DateRangePicker from "../../components/DateRangePicker/DateRangePicker";
import "../../components/styled/style-cardDrivers.css";
import "./background.css";
import BotonGlobalExportarEstados from "../../components/BotonGlobalExportarEstados/BotonGlobalExportarEstados";
import BotonGlobalCalculateCuotas from "../../components/BotonGlobalUserCuotas/BotonGlobalUserCuotas";
import BotonGlobalExportarExcel from "../../components/BotonGlobalExportarExcel/BotonGlobalExportarExcel";
import DropDownListRangeFilter from "../../components/DropDownListDateRangeFilter/DropDownListRangeFilter";
import ClaerFilter_Icon from "../../components/icons/ClearFilter_Icon";
import TableDrivers from "../../components/drivers-list/TableDrivers";
import Switch from "react-switch";

function ListDrivers() {
  const { getTravelsHasura } = GetDrivers();
  const [drivers_Found, setDriverfound] = useState([]);
  const [selectedOption, setSelectedOption] = useState("Ver todos");
  const [Loading, setLoading] = useState(false);
  const copybundledDrivers = [...drivers_Found];
  const [driversFound, setDrivers] = useState([]);
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);
  const [startDate, endDate] = dateRange;
  const [name, setName] = useState("");
  const [checked, setswitch] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  async function getTravelsHasuras(env) {
    setLoading(true);
    try {
      const response_hasura = await getTravelsHasura(0, "Terminado");
      const groupedData = {};

      response_hasura.forEach((data_travel) => {
        const { driver_data, environment } = data_travel;

        if (driver_data === null) return;
        const environmentHasura = Number(environment);
        if (environmentHasura === env) {
          const { driver_id, ...rest } = driver_data;
          if (!groupedData[driver_id]) {
            groupedData[driver_id] = {
              driver_info: rest,
              travel_matches: [],
            };
          }
          groupedData[driver_id].travel_matches.push(data_travel);
        }
      });
      const result = Object.keys(groupedData).map((driver_id) => ({
        driver_id: driver_id,
        ...groupedData[driver_id],
      }));

      setDriverfound(result);

      setLoading(false);
      /*     google.accounts.id.prompt(); */
    } catch (error) {
      // console.log("🚀 ~ file: index.js:60 ~ getTravelsHasuras ~ error:", error);
      setDriverfound([]);
      setLoading(false);
    }
  }

  useEffect(() => {
    getTravelsHasuras(2);
  }, []);

  useEffect(() => {
    setDrivers(drivers_Found);
  }, [drivers_Found]);

  useEffect(() => {
    if ((dateRange[0] !== null) & (dateRange[1] !== null)) {
      if (
        startDate.toISOString().substring(0, 10) !==
        new Date().toISOString().substring(0, 10)
      ) {
        filterByDate(dateRange[0], dateRange[1]);
      }
    }
  }, [dateRange]);

  useEffect(() => {
    if (selectedOption === "Ver todos") {
      setDrivers(drivers_Found);
    } else if (selectedOption === "Mes pasado") {
      const prevMonthStartDate = new Date();
      const prevMonthEndDate = new Date();
      prevMonthStartDate.setDate(1);
      prevMonthStartDate.setHours(0, 0, 0, 0);
      prevMonthStartDate.setMonth(prevMonthStartDate.getMonth() - 1);
      prevMonthEndDate.setDate(0);
      prevMonthEndDate.setHours(23, 59, 59, 999);
      prevMonthEndDate.setMonth(prevMonthEndDate.getMonth());
      console.log("Mes pasado", { prevMonthStartDate, prevMonthEndDate });
      /*       setDateRange([prevMonthStartDate, prevMonthEndDate]); */
      filterByDate(prevMonthStartDate, prevMonthEndDate);
    } else if (selectedOption === "Mes actual") {
      const currentDate = new Date();
      const currentMonthStartDate = new Date(dateRange[0]);
      currentMonthStartDate.setDate(1);
      currentMonthStartDate.setHours(0, 0, 0, 0);
      /*  setDateRange([currentMonthStartDate, currentDate]); */
      filterByDate(currentMonthStartDate, currentDate);
    } else if (selectedOption === "Año pasado") {
      const lastYearStartDate = new Date();
      const lastYearEndDate = new Date();
      lastYearStartDate.setFullYear(lastYearStartDate.getFullYear() - 1);
      lastYearStartDate.setMonth(0);
      lastYearStartDate.setDate(1);
      lastYearStartDate.setHours(0, 0, 0, 0);
      lastYearEndDate.setFullYear(lastYearEndDate.getFullYear() - 1);
      lastYearEndDate.setMonth(11);
      lastYearEndDate.setDate(31);
      lastYearEndDate.setHours(23, 59, 59, 999);
      /* setDateRange([lastYearStartDate, lastYearEndDate]); */
      filterByDate(lastYearStartDate, lastYearEndDate);
    } else if (selectedOption === "Año actual") {
      const lastYearStartDate = new Date();
      const lastYearEndDate = new Date();
      lastYearStartDate.setFullYear(lastYearStartDate.getFullYear());
      lastYearStartDate.setMonth(0);
      lastYearStartDate.setDate(1);
      lastYearStartDate.setHours(0, 0, 0, 0);

      /* setDateRange([lastYearStartDate, lastYearEndDate]); */
      filterByDate(lastYearStartDate, lastYearEndDate);
    }
  }, [selectedOption]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const filterByDate = async (minDate, maxDate) => {
    minDate.setHours(0, 0, 0, 0);
    maxDate.setHours(23, 59, 59, 999);

    let filteredByDate = [];
    for (let i = 0; i <= copybundledDrivers.length - 1; i++) {
      let newtravels = copybundledDrivers[i].travel_matches.filter((viaje) => {
        const fechasolicitud = new Date(viaje?.time_request);

        return fechasolicitud >= minDate && fechasolicitud <= maxDate;
      });

      if (newtravels.length > 0) {
        let copyDriver = { ...copybundledDrivers[i] };
        copyDriver.travel_matches = newtravels;
        filteredByDate.push(copyDriver);
      }
    }

    setDrivers(filteredByDate);
  };

  function searchForName(searchTerm) {
    const copybundledDrivers = [...drivers_Found];
    const matchingDrivers = copybundledDrivers.filter((driver) => {
      const driverName = driver?.driver_info?.name.toLowerCase();
      const searchLower = searchTerm.toLowerCase();
      return driverName.includes(searchLower);
    });

    setDrivers(matchingDrivers);
  }

  async function cleanFilter() {
    setDrivers(drivers_Found);
    setDateRange([new Date(), new Date()]);
  }
  async function cleanFilterSearch() {
    setDrivers(drivers_Found);
    setName("");
  }
  const DriversItems = driversFound.map((driver, index) => {
    return <DriverCard key={index} driver={driver} />;
  });

  async function handleChange(checked) {
    if (checked === true) getTravelsHasuras(1);
    if (checked === false) getTravelsHasuras(2); // Producción
    setswitch(checked);
  }

  if (Loading) {
    return (
      <LoadingModal
        onClose={!Loading}
        open={Loading}
        text={"Procesando conductores, estamos haciendo cuentas..."}
      />
    );
  }

  return (
    <>
      <section className="dispersion-delivery">
        <div className="dispersion-delivery-top">
          <div className="bar-options">
            <InputSearch
              placeholder={"Conductores registrados..."}
              onClick={() => searchForName(name)}
              setName={setName}
              name={name}
              controlWidth={windowWidth}
            />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                justifyContent: "space-between",
                border: "1px solid #E8E8E8",
                padding: "5px",
                borderRadius: "10px",
                alignItems: "center",
                height: "2rem",
              }}
            >
              <p style={{ color: "#333", fontWeight: "500" }}>
                Modo de pruebas
              </p>

              <Switch
                onColor="#004990"
                onChange={handleChange}
                checked={checked}
              />
            </div>
            <div
              style={{
                display: "flex",
                gap: "30px",
                position: "relative",
              }}
            >
              <DateRangePicker
                startDate={startDate}
                endDate={endDate}
                setDateRange={setDateRange}
                disabled={false}
                maxDate={new Date()}
                controlWidth={windowWidth}
              />
              {startDate.toISOString().substring(0, 10) !==
              new Date().toISOString().substring(0, 10) ? (
                <button
                  style={{
                    cursor: "pointer",
                    border: "none",
                    borderRadius: "5px",
                    backgroundColor: "#004990",
                  }}
                  onClick={() => cleanFilter()}
                >
                  <ClaerFilter_Icon color={"#ffffff"} />
                </button>
              ) : DriversItems.length === 0 ? (
                <button
                  style={{
                    cursor: "pointer",
                    border: "none",
                    borderRadius: "5px",
                    backgroundColor: "#004990",
                  }}
                  onClick={() => cleanFilterSearch()}
                >
                  <ClaerFilter_Icon color={"#ffffff"} />
                </button>
              ) : null}
            </div>
            <DropDownListRangeFilter
              selectedOption={selectedOption}
              setSelectedOption={setSelectedOption}
              controlWidth={windowWidth}
            />
          </div>

          {driversFound.length > 0 ? (
            <TableDrivers Drivers={driversFound} />
          ) : (
            <div>no se encontraron conductores</div>
          )}
        </div>
        {/*         <BotonGlobalCalculateCuotas arre_travels={driversFound} />
        <BotonGlobalExportarEstados arre_travels={driversFound} /> */}
        <BotonGlobalExportarExcel
          arre_travels={driversFound}
          dateRange={dateRange}
        />
      </section>
    </>
  );
}
export default ListDrivers;
